import { SocnetHh, SocnetVk, SocnetYt, SocnetTg } from "../../../assets/svg/index";

const linkProps = { target: "__blank", rel: "noopener noreferrer" };

const links = [
  {
    href: "https://vk.com/bcs_world_of_investments",
    icon: <SocnetVk />
  },
  {
    href: "https://www.youtube.com/@BrokerRu",
    icon: <SocnetYt />
  },
  {
    href: "https://hh.ru/employer/1833",
    icon: <SocnetHh />
  },
  {
    href: "https://t.me/bcs_world_of_investments",
    icon: <SocnetTg />
  },
]

export { links, linkProps };
